export default __webpack_public_path__ + "static/media/vertical-image.45b98e3f.png";